import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import merge from 'lodash/merge';

export default class ClaimSupportingInfo extends BackboneElement {
    static __className = 'ClaimSupportingInfo';

    __objectStructure = {
        sequence: Number,
        category: CodeableConcept,
        code: CodeableConcept,
        reason: CodeableConcept,
    };

    constructor(constructJson, className = 'ClaimSupportingInfo') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
